import { render, staticRenderFns } from "./NumberToStringConverter.vue?vue&type=template&id=fdf97e00&"
import script from "./NumberToStringConverter.vue?vue&type=script&lang=ts&"
export * from "./NumberToStringConverter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports